/**
 * A page whose sidebar entry was not drawn for this person is not shown, however
 * it was reached: a link, a bookmark or a typed address. The sidebar's own rule
 * decides (useCanOpen). While the sidebar has not drawn yet the page shows as
 * before; the server refuses its data either way.
 */
import type { ReactNode } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useCanOpen } from '../lib/useCanOpen';

export function PageGuard({ children }: { children: ReactNode }): JSX.Element {
  const { t } = useTranslation('common');
  const { pathname, search } = useLocation();
  const canOpen = useCanOpen();
  if (canOpen(`${pathname}${search}`) !== false) return <>{children}</>;
  return (
    <div className="content">
      <div className="pg-stack pg-std">
        <div className="card" data-testid="page-not-available">
          <div className="ch"><span className="ct">{t('page_guard.title')}</span></div>
          <div className="cb" style={{ color: 'var(--muted)' }}>{t('page_guard.body')}</div>
        </div>
      </div>
    </div>
  );
}
